import { c as _c } from "react/compiler-runtime";
import { Link } from 'react-router';
export function NoMatch() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><h2>It looks like you're lost...</h2><p><Link to="/">Go to the home page</Link></p></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}